import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { SectionHeader } from "@/components/Bits";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { AMENITIES, IMG } from "@/data/site";
import * as Icons from "lucide-react";

export default function Amenities() {
  return (
    <>
      <Seo
        title="Hotel Amenities in Ottawa, KS"
        description="Amenities at Super 8 by Wyndham Ottawa, Kansas: heated indoor pool, free SuperStart breakfast, free WiFi, free truck/RV/bus parking, guest laundry, 24-hour front desk, accessible rooms and more."
        path="/amenities"
        image={IMG.breakfast}
        breadcrumbs={[{ name: "Home", path: "/" }, { name: "Amenities", path: "/amenities" }]}
      />
      <PageHero
        kicker="Amenities"
        lines={["The good", "stuff, all", "included"]}
        sub="No nickel-and-diming. Free breakfast, free WiFi, a year-round indoor pool and parking for anything you drive — plus the thoughtful extras that make a stay easy."
        image={IMG.breakfast}
      />

      <section className="mx-auto max-w-[1400px] px-5 py-24 md:px-10 md:py-32">
        <SectionHeader kicker="Everything We Offer" title="Amenities, in full" />
        <div className="mt-14 grid grid-cols-1 border-l border-t border-charcoal/10 sm:grid-cols-2 lg:grid-cols-3">
          {AMENITIES.map((a, i) => {
            const Icon = Icons[a.icon] || Icons.Sparkles;
            return (
              <Reveal
                key={a.name}
                i={i % 3}
                className="group border-b border-r border-charcoal/10 p-8 transition-colors duration-300 hover:bg-brand-yellow"
              >
                <Icon className="h-8 w-8 text-brand-red transition-transform duration-300 group-hover:scale-110" />
                <h3 className="mt-6 font-heading text-lg font-black text-charcoal">{a.name}</h3>
                <p className="mt-2 font-body text-sm leading-relaxed text-fog group-hover:text-charcoal/80">{a.desc}</p>
              </Reveal>
            );
          })}
        </div>
      </section>
      <EditorialMarquee items={["Free Breakfast", "Free WiFi", "Indoor Pool", "Truck Parking"]} />
    </>
  );
}
